 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import A780802157027 from '@/components/9780802157027'
 import A7808021570271 from '@/components/97808021570271'
 import A7808021570272 from '@/components/97808021570272'
 import A7808021570273 from '@/components/97808021570273'
 import A7808021570274 from '@/components/97808021570274'
 import A7808021570275 from '@/components/97808021570275'
 import A7808021570276 from '@/components/97808021570276'
 import A7808021570277 from '@/components/97808021570277'
 import A7808021570278 from '@/components/97808021570278'
 import A7808021570279 from '@/components/97808021570279'
 import LOVE_2 from '@/components/love_2'
 import A78080215702710 from '@/components/978080215702710'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9780802157027",
 			"name" : "9780802157027",
 			"component" : A780802157027
 		},
 		{
 			"path" : "/97808021570271",
 			"name" : "97808021570271",
 			"component" : A7808021570271
 		},
 		{
 			"path" : "/97808021570272",
 			"name" : "97808021570272",
 			"component" : A7808021570272
 		},
 		{
 			"path" : "/97808021570273",
 			"name" : "97808021570273",
 			"component" : A7808021570273
 		},
 		{
 			"path" : "/97808021570274",
 			"name" : "97808021570274",
 			"component" : A7808021570274
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js